import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

export const RegistrationWizardTerms = () => (
    <div className={termsStyle}>
        <Text as="p" variant="info_txt_1" strong>
            Akceptuję{" "}
            <a href={rpAppLink.termsOfService.base()} target="_blank" rel="noopener noreferrer" className={linkStyle}>
                regulamin serwisu
            </a>
        </Text>
        <div className={noticeStyle}>
            <Text as="p" variant="info_txt_3">
                Uruchamiam darmową usługę Home Match, czyli automatycznego dopasowania i zarządzania ofertami w ramach konta mieszkaniowego.
            </Text>
            <Text as="p" variant="info_txt_3">
                Administratorem danych osobowych jest Property Group sp. z o.o.
                <br />
                <a href={rpAppLink.rodoTerms.base()} target="_blank" rel="noopener noreferrer" className={linkStyle}>
                    Przeczytaj politykę prywatności.
                </a>
            </Text>
        </div>
    </div>
);

const termsStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    pt: 1,
    color: "var(--colors-gray-700)"
});

const noticeStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1.5
});

const linkStyle = css({
    color: "inherit",
    fontWeight: "bold",
    textDecoration: "underline"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

export const RegistrationWizardTerms = () => (
    <div className={termsStyle}>
        <Text as="p" variant="info_txt_1" strong>
            Akceptuję{" "}
            <a href={rpAppLink.termsOfService.base()} target="_blank" rel="noopener noreferrer" className={linkStyle}>
                regulamin serwisu
            </a>
        </Text>
        <div className={noticeStyle}>
            <Text as="p" variant="info_txt_3">
                Uruchamiam darmową usługę Home Match, czyli automatycznego dopasowania i zarządzania ofertami w ramach konta mieszkaniowego.
            </Text>
            <Text as="p" variant="info_txt_3">
                Administratorem danych osobowych jest Property Group sp. z o.o.
                <br />
                <a href={rpAppLink.rodoTerms.base()} target="_blank" rel="noopener noreferrer" className={linkStyle}>
                    Przeczytaj politykę prywatności.
                </a>
            </Text>
        </div>
    </div>
);

const termsStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    pt: 1,
    color: "var(--colors-gray-700)"
});

const noticeStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1.5
});

const linkStyle = css({
    color: "inherit",
    fontWeight: "bold",
    textDecoration: "underline"
});
